
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5kEnh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $3ouAo = parcelRequire("3ouAo");


var $gVzI4 = parcelRequire("gVzI4");


var $hA5CC = parcelRequire("hA5CC");


var $4LzvV = parcelRequire("4LzvV");

const $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ad79fa1eeebb4272$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: (0, $gVzI4.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $l998X.jsx)("a", {
                href: (0, $gVzI4.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $l998X.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $hA5CC.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $42omo.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($3ouAo)))
        ]);
    }, []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ouAo))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $hA5CC.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $gVzI4.ADMIN_LINK),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $ad79fa1eeebb4272$export$2e2bcd8739ae039 = $ad79fa1eeebb4272$var$AiOptIn;
module.exports["default"] = $ad79fa1eeebb4272$export$2e2bcd8739ae039;

});

parcelRegister("3ouAo", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.cf053e66.svg", import.meta.url).toString();

});

parcelRegister("gVzI4", function(module, exports) {
const $30266e962d22c479$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $30266e962d22c479$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';
module.exports["AI_LINK"] = $30266e962d22c479$export$550fac1a4ec3d365;
module.exports["ADMIN_LINK"] = $30266e962d22c479$export$bae9a077d7ed5dfe;

});

parcelRegister("hA5CC", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $55820977c77a8e8c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Messages for the AI Global Opt-in component
   */ aiOptInDialogHeaderText: {
        id: "ai-opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiOptInDialogBodyText: {
        id: "ai-opt-in.dialog.body.text",
        defaultMessage: "Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    aiOptInDialogLearnMoreLinkText: {
        id: "ai-opt-in.dialog.learn-more.link.text",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    aiOptInDialogAdminBodyText: {
        id: "ai-opt-in.dialog.admin.body.text",
        defaultMessage: "Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: "ai-opt-in.dialog.admin.maybe-later.button.text",
        defaultMessage: "Maybe later"
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: "ai-opt-in.dialog.admin.get-started.button.text",
        defaultMessage: "Get started"
    },
    aiOptInBannerBodyText: {
        id: "ai-opt-in.banner.body.text",
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it."
    },
    aiOptInBannerLearnMoreText: {
        id: "ai-opt-in.banner.learn.more.text",
        defaultMessage: "Learn more"
    },
    aiOptInAdminBannerBodyText: {
        id: "ai-opt-in.banner.admin.body.text",
        defaultMessage: "Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration."
    },
    aiOptInAdminOnlyVisible: {
        id: "ai-opt-in.admin.only.visible.text",
        defaultMessage: "This message is only visible to org admins."
    }
});
module.exports["messages"] = $55820977c77a8e8c$export$defe85febe8b728c;

});

parcelRegister("4LzvV", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $3161983b4d5922a4$export$24c280970213bb11 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $7sObp.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _11q71lxv _16qs130s _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1cku _1e0c1txw _1biu1cku _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81e3o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$14966827497f4695 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});
module.exports["OptInBackgroundBorder"] = $3161983b4d5922a4$export$24c280970213bb11;
module.exports["OptInContainer"] = $3161983b4d5922a4$export$a0fab83bea8ccf2e;
module.exports["ImageWrapper"] = $3161983b4d5922a4$export$75f07c36086c2c81;
module.exports["ContentContainer"] = $3161983b4d5922a4$export$9d2b4227a95687cc;
module.exports["HeaderWrapper"] = $3161983b4d5922a4$export$960a49cc3d27a090;
module.exports["BodyWrapper"] = $3161983b4d5922a4$export$14966827497f4695;
module.exports["ButtonContainer"] = $3161983b4d5922a4$export$eddf54ea3db8d0f0;

});

parcelRegister("42MJM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cOrQJ = parcelRequire("cOrQJ");


var $inPa6 = parcelRequire("inPa6");


var $lHQAj = parcelRequire("lHQAj");


var $euL71 = parcelRequire("euL71");


var $cHKtk = parcelRequire("cHKtk");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$UpsellBackgroundBorder = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _1yt4v77o _11q7kwyp _16qs130s _1bsb1kdj _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _1yt4v77o _11q7kwyp _16qs130s _1bsb1kdj _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$UpsellContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$ImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1cku _4t3iys9h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1cku _4t3iys9h",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zbay22hw _155npxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zbay22hw _155npxbi",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$export$38f23d3987aa9723 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { title: title, body: body, feature: feature, image: image, learnMoreLink: learnMoreLink, onRender: onRender } = t0;
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(`${feature}UpsellScreen`);
    let t1;
    if ($[0] !== learnMoreLink.message || $[1] !== showRequestUpgradeButton) {
        t1 = showRequestUpgradeButton ? {
            id: "change-edition.ai-upsell.learn-more.with-end-user-request-button",
            defaultMessage: "Learn more",
            description: "Learn more link label when end user request upgrade button is present"
        } : {
            id: "change-edition.ai-upsell.learn-more",
            defaultMessage: learnMoreLink.message
        };
        $[0] = learnMoreLink.message;
        $[1] = showRequestUpgradeButton;
        $[2] = t1;
    } else t1 = $[2];
    const learnMoreLinkMessageDescriptor = t1;
    const bannerImage = colorMode === "dark" ? image?.src.dark : image?.src.default;
    let t2;
    let t3;
    if ($[3] !== onRender) {
        t2 = ()=>{
            if (onRender) onRender();
        };
        t3 = [
            onRender
        ];
        $[3] = onRender;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== bannerImage) {
        t4 = ()=>{
            if (bannerImage) {
                const preloadImages = $20dc6939391e7f10$var$_temp2;
                preloadImages([
                    bannerImage
                ]);
            }
        };
        t5 = [
            bannerImage
        ];
        $[6] = bannerImage;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[9] !== createAnalyticsEvent || $[10] !== feature) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "aiUpsellDialog",
                    attributes: {
                        feature: feature
                    }
                }
            }).fire();
        };
        t7 = [
            createAnalyticsEvent,
            feature
        ];
        $[9] = createAnalyticsEvent;
        $[10] = feature;
        $[11] = t6;
        $[12] = t7;
    } else {
        t6 = $[11];
        t7 = $[12];
    }
    (0, $42omo.useEffect)(t6, t7);
    const t8 = `${feature}LearnMore`;
    let t9;
    if ($[13] !== learnMoreLink || $[14] !== learnMoreLinkMessageDescriptor || $[15] !== t8) {
        t9 = {
            ...learnMoreLink,
            messageDescriptor: learnMoreLinkMessageDescriptor,
            actionSubjectId: t8
        };
        $[13] = learnMoreLink;
        $[14] = learnMoreLinkMessageDescriptor;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    const t10 = `${feature}UpsellScreen`;
    const t11 = `${feature}TryPremium`;
    let t12;
    if ($[17] !== bannerImage) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ImageWrapper, {
            src: bannerImage
        });
        $[17] = bannerImage;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== body || $[20] !== loading || $[21] !== showRequestUpgradeButton || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t9 || $[26] !== title) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellBackgroundBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
            title: title,
            body: body,
            learnMoreLink: t9,
            source: t10,
            targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
            upgradeEditionActionSubjectId: t11,
            isLoadingRequestUpgradeButton: loading,
            showRequestUpgradeButton: showRequestUpgradeButton
        }, t12))));
        $[19] = body;
        $[20] = loading;
        $[21] = showRequestUpgradeButton;
        $[22] = t10;
        $[23] = t11;
        $[24] = t12;
        $[25] = t9;
        $[26] = title;
        $[27] = t13;
    } else t13 = $[27];
    return t13;
} : ({ title: title, body: body, feature: feature, image: image, learnMoreLink: learnMoreLink, onRender: onRender })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(`${feature}UpsellScreen`);
    const learnMoreLinkMessageDescriptor = (0, $42omo.useMemo)(()=>{
        return showRequestUpgradeButton ? {
            id: 'change-edition.ai-upsell.learn-more.with-end-user-request-button',
            defaultMessage: 'Learn more',
            description: 'Learn more link label when end user request upgrade button is present'
        } : {
            id: 'change-edition.ai-upsell.learn-more',
            defaultMessage: learnMoreLink.message
        };
    }, [
        showRequestUpgradeButton,
        learnMoreLink.message
    ]);
    const bannerImage = colorMode === 'dark' ? image?.src.dark : image?.src.default;
    (0, $42omo.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    (0, $42omo.useEffect)(()=>{
        if (bannerImage) {
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                bannerImage
            ]);
        }
    }, [
        bannerImage
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiUpsellDialog',
                attributes: {
                    feature: feature
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        feature
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellBackgroundBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
        title: title,
        body: body,
        learnMoreLink: {
            ...learnMoreLink,
            messageDescriptor: learnMoreLinkMessageDescriptor,
            actionSubjectId: `${feature}LearnMore`
        },
        source: `${feature}UpsellScreen`,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        upgradeEditionActionSubjectId: `${feature}TryPremium`,
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ImageWrapper, {
        src: bannerImage
    })))));
};
function $20dc6939391e7f10$var$_temp(path) {
    const img = new Image();
    img.src = path;
}
function $20dc6939391e7f10$var$_temp2(paths) {
    paths.forEach($20dc6939391e7f10$var$_temp);
}
module.exports["AIUpsell"] = $20dc6939391e7f10$export$38f23d3987aa9723;

});

parcelRegister("48ubT", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $w033M = parcelRequire("w033M");

const $cfdb58fabb92c022$export$f9f8a5cdb0c565ef = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsSiteAdminUseIsSiteAdminQuery{isSiteAdmin}`);
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(data);
    return {
        isSiteAdmin: isSiteAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsSiteAdmin"] = $cfdb58fabb92c022$export$f9f8a5cdb0c565ef;

});

parcelRegister("4acD6", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $48675c89bdefef9d$export$d4c72bab9d6cc13a = {
    nudges: []
};
const $48675c89bdefef9d$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        }
};
const $48675c89bdefef9d$export$72552b26ebb37b2 = (0, $1P1Tu.createStore)({
    initialState: $48675c89bdefef9d$export$d4c72bab9d6cc13a,
    actions: $48675c89bdefef9d$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $48675c89bdefef9d$export$af36d029992e7a8c = (0, $9zUhf.createActionsHook)($48675c89bdefef9d$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $48675c89bdefef9d$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $48675c89bdefef9d$export$af36d029992e7a8c;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: []
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $1P1Tu.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $9zUhf.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;

});


//# sourceMappingURL=InvalidExtension.a4db3322.js.map
